import plusIcon from "../../../../images/plus-solid.png";
import checkIcon from "../../../../images/check-solid.png";
import * as CommonUtilities from "../../../../common/utils/CommonUtils";

export default function ProductComboProduct(props) {
    let buttonImageToDisplay;
    let productTextDisplay;
    let modifiersToDisplay, modifierDisplayContainer, specialInstrDisplay = "";
    let hasErrorClass = "";
    if (props.groupValidationData.HasError) {
        hasErrorClass = "is-invalid border-danger";
    } else {
        hasErrorClass = "";
    }

    if (props.groupFormData.ProductID == null || props.groupFormData.ProductID == '') {
        productTextDisplay = `Choose ${props.productComboGroupDetails.productComboGroupName}`
        buttonImageToDisplay = <span className="bg-dark rounded-pill" style={{width: "20px", height: "20px", minWidth: "20px"}}><img src={plusIcon} alt="Add" title="Add" className="mb-1 pb-1" style={{width: "10px"}}></img></span>
    } else {
        productTextDisplay = `${props.groupFormData.ProductName}`
        buttonImageToDisplay = <span className="bg-success rounded-pill" style={{width: "20px", height: "20px"}}><img src={checkIcon} alt="Selected" className="mb-1 pb-1" style={{width: "10px"}}></img></span>
        
        // Display Modifiers
        if (props.groupFormData.Mods.length > 0) {
            /* Summary of what was chosen for this combo slot.

               ⚠ A substitution line (Field starts "SubRadio") is a DIFFERENCE
               against the slot's original product, not a price — the combo is
               sold at a set price. So it shows "+$2.50" when the swap costs
               extra and NOTHING when it is the same or smaller. Add-ons keep
               their own price, because they genuinely are extras.

               This restores the logic that was sitting commented out here, with
               the downgrade case floored at zero to match the server clamp in
               TemporaryUserCartRepository. */
            modifiersToDisplay = props.groupFormData.Mods.map((item) => {
                const isSubstitution = item.Field.startsWith("SubRadio");
                let priceNode;

                if (isSubstitution) {
                    /* PriceIncForComboSubstitution starts as '' and is filled in
                       when a product is chosen for the slot. If it is somehow
                       still blank, show nothing rather than treat the base as
                       zero — that would print the substitute's whole price as a
                       surcharge, overstating what the customer pays. */
                    const base = props.groupFormData.PriceIncForComboSubstitution;
                    const baseIsKnown = base !== '' && base !== null && base !== undefined && !isNaN(base);
                    const delta = baseIsKnown ? item.PriceInc - base : 0;
                    priceNode = delta > 0
                        ? <span className="ms-2 ps-1">+{CommonUtilities.formatDisplayPrice(delta)}</span>
                        : null;
                } else {
                    priceNode = item.PriceInc != 0
                        ? <span className="ms-2 ps-1">{CommonUtilities.formatDisplayPrice(item.PriceInc)}</span>
                        : null;
                }

                return <li key={item.PLU}>{item.ModName}{priceNode}</li>
            });
            modifierDisplayContainer = 
                <small className="text-muted">
                    <ul className="mb-0">
                        {modifiersToDisplay}
                    </ul>
                </small>
        } else {
            modifierDisplayContainer = <></>;
        }
        
        // Display Special Instructions
        if (props.groupFormData.SpecialInstructions !== '' && props.groupFormData.SpecialInstructions !== null) {
            specialInstrDisplay = <small className="text-muted mt-2"><span className="fw-medium">Note: </span>{props.groupFormData.SpecialInstructions}</small>
        } else {
            specialInstrDisplay = <></>;
        }
    }

    return (
        <div className="col-12 py-2 d-grid">
            <button type="button" className={`btn btn-light border d-flex flex-row justify-content-start align-items-center py-3 ${hasErrorClass}`} data-productcombogroupid={props.productComboGroupDetails.productComboGroupID} onClick={props.handleProductComboGroupSelect} disabled={props.addToCartError.ButtonsDisabled}>
                {buttonImageToDisplay}
                &emsp;<div className="d-flex flex-column align-items-start text-start text-break">
                    <span>{productTextDisplay}</span>
                    {modifierDisplayContainer}
                    {specialInstrDisplay}
                </div>
            </button>
            <div className="invalid-feedback">{props.groupValidationData.ErrorMessage}</div>
        </div>
    )
}